import { SignatureRequest } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";

import { queriesSignatureRequests } from "../../../../../../v3/query/queriesSignatureRequests";
import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getSignatureRequestFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): SignatureRequest | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  return WSQueryCache.getQueryData<SignatureRequest>(
    queriesSignatureRequests.getSignatureRequest.getQueryKey({
      requestId: requirement.dataSourceId
    })
  );
};
